import React, { useState } from "react";
import { generarHojaDiariaPDF } from "../../../../pdf/hojaDiariaPDF";
import { toast } from "react-toastify";
import { getHojaDiaria, auditarHojaDiariaExportada } from "../../../../services/historiaClinica";

const ModalHojaDiaria = ({
  isOpen,
  onClose,
  medico = {},
}) => {
  const getFechaLocal = () => {
  const hoyLocal = new Date();
  const year = hoyLocal.getFullYear();
  const month = String(hoyLocal.getMonth() + 1).padStart(2, "0");
  const day = String(hoyLocal.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

const hoy = getFechaLocal();
const excedeTresMeses = (inicio, fin) => {
  const fechaInicioDate = new Date(`${inicio}T00:00:00`);
  const fechaFinDate = new Date(`${fin}T00:00:00`);

  const limite = new Date(fechaInicioDate);
  limite.setMonth(limite.getMonth() + 3);

  return fechaFinDate > limite;
};

  const [fechaInicio, setFechaInicio] = useState(hoy);
  const [fechaFin, setFechaFin] = useState(hoy);
  const [exportando, setExportando] = useState(false);

  if (!isOpen) return null;

  const handleExportar = async () => {
  if (!fechaInicio || !fechaFin) {
    toast.error("Selecciona fecha inicio y fecha fin.");
    return;
  }

  if (fechaInicio > hoy || fechaFin > hoy) {
    toast.error("No puedes exportar fechas futuras.");
    return;
  }

  if (new Date(fechaInicio) > new Date(fechaFin)) {
    toast.error("La fecha inicio no puede ser mayor a la fecha fin.");
    return;
  }

  if (excedeTresMeses(fechaInicio, fechaFin)) {
    toast.error("El rango máximo permitido a exportar por ocasión es de 3 meses. Selecciona un periodo más corto.");
    return;
  }

  try {
    setExportando(true);

    const registrosHojaDiaria = await getHojaDiaria(fechaInicio, fechaFin);

    if (!Array.isArray(registrosHojaDiaria) || registrosHojaDiaria.length === 0) {
      toast.info("No se encontraron registros en el rango seleccionado.");
      return;
    }
    
    await auditarHojaDiariaExportada({
      fechaInicio,
      fechaFin,
      totalRegistros: registrosHojaDiaria.length,
    });

    const pacientesParaPDF = registrosHojaDiaria.map((registro) => {
      const paciente = registro.paciente || {};

      return {
        id: paciente.id,
        nombre: paciente.nombre,
        apellido_paterno: paciente.apellido_paterno,
        apellido_materno: paciente.apellido_materno,
        fecha_nacimiento: paciente.fecha_nacimiento,
        sexo: paciente.sexo,
        historia:
          registro.tipo_registro === "historia_clinica"
            ? {
                id: registro.historia_id,
                fecha_consulta: registro.fecha_consulta,
              }
            : null,
        consultas:
          registro.tipo_registro === "consulta"
            ? [
                {
                  id: registro.consulta_id,
                  fecha_consulta: registro.fecha_consulta,
                },
              ]
            : [],
      };
    });

    generarHojaDiariaPDF({
      pacientes: pacientesParaPDF,
      fechaInicio,
      fechaFin,
      medico,
    });

    onClose();
  } catch (error) {
    console.error("Error exportando hoja diaria:", error);
    toast.error("No se pudo generar la hoja diaria. Intenta de nuevo.");
  } finally {
    setExportando(false);
  }
};

  return (
    <div className="modal-overlay">
      <div className="modal-content modal-hoja-diaria">
        <div className="modal-header">
          <h3>Exportar hoja diaria</h3>
       
        </div>

        <div className="modal-body">
          <p style={{ marginTop: 0 }}>
            Selecciona el periodo de consultas que quieres incluir.
            El PDF se agrupará por día usando la fecha de consulta.
          </p>

          <div className="form-group">
            <label>Fecha inicio</label>
           <input
            type="date"
            value={fechaInicio}
            max={hoy}
            onChange={(e) => setFechaInicio(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>Fecha fin</label>
           <input
            type="date"
            value={fechaFin}
            max={hoy}
            onChange={(e) => setFechaFin(e.target.value)}
            />
          </div>
        </div>

        <div className="modal-actions">
          <button
            type="button"
            className="btn-secundario"
            onClick={onClose}
          >
            Atrás
          </button>

         <button
  type="button"
  className="btn-primario"
  onClick={handleExportar}
  disabled={exportando}
>
  {exportando ? "Generando..." : "Exportar PDF"}
</button>
        </div>
      </div>
    </div>
  );
};

export default ModalHojaDiaria;